import { CatchUpDateIcon } from "components/icons";
import { cn } from "lib/utils";
import { OneOnOneNotesResponse } from "responses";
import {
  RISK_LEVEL_DISPLAY,
  RiskLevel,
  formatCatchUpDate,
} from "utils/one-on-one-notes.util";
import OneOnOneNoteField from "./OneOnOneNoteField";

type OneOnOneNoteCardProps = {
  note: OneOnOneNotesResponse;
  onViewDetails: () => void;
};

const OneOnOneNoteCard = ({ note, onViewDetails }: OneOnOneNoteCardProps) => {
  const riskLevelDotClassName =
    RISK_LEVEL_DISPLAY[note.riskLevel as RiskLevel]?.dotClassName ??
    "bg-neutral-50";

  return (
    <article
      className="flex h-full cursor-pointer flex-col rounded-2xl border-2 border-transparent bg-blue-10 p-6 transition-colors hover:border-turquoise-100"
      onClick={onViewDetails}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onViewDetails();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="mb-6 flex items-center justify-between gap-4">
        <div className="shrink-0 rounded-full bg-blue-200 p-1 text-white">
          <CatchUpDateIcon />
        </div>
        <p className="body-14-semibold">
          {formatCatchUpDate(note.lastCatchUp)}
        </p>
      </div>

      <div className="space-y-5">
        <OneOnOneNoteField label="Email" value={note.email} />
        <OneOnOneNoteField label="TM In Charge" value={note.tmInCharge} />

        <div className="space-y-5 border-t border-neutral-10 pt-5">
          <OneOnOneNoteField
            label="Latest Feedback"
            value={note.latestFeedback}
          />
          <OneOnOneNoteField
            label="[Summary] Expectation"
            value={note.expectation}
          />
          <OneOnOneNoteField
            label="[Summary] Support Needed"
            value={note.supportNeeded}
          />

          <div className="space-y-1">
            <p className="body-16-semibold">Risk Level</p>
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "h-2.5 w-2.5 rounded-full",
                  riskLevelDotClassName,
                )}
              />
              <p className="body-14-regular">{note.riskLevel || "—"}</p>
            </div>
          </div>

          <OneOnOneNoteField label="Action Needed" value={note.actionNeeded} />
        </div>
      </div>
    </article>
  );
};

export default OneOnOneNoteCard;
